import { createAsyncThunk } from '@reduxjs/toolkit'

import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { callErrorMsg } from 'helpers/errorMsg'
import { getCleanQueryObj } from 'utils/queryParamsURL'
import { toastSuccess } from 'utils/toast'
import {
  TimeSlotParamType,
  putTimeSlotApi,
  UpdateTimeSlotDataType,
  fetchTimeSlotListApi,
  upsertFcfsTimeSlotApi,
  type TimeSlotDataType,
  type UpsertFcfsTimeSlotDataType,
} from 'features/Enterprise/CapacityHandler/services/timeSlot'

export const SLICE_NAME = 'slotTime'

export const fetchTimeSlotList = createAsyncThunk<TimeSlotDataType[], undefined, RejectValueType>(
  `${SLICE_NAME}/fetchTimeSlotList`,
  async (_, { rejectWithValue, getState }) => {
    const {
      timeSlot: { query },
    } = getState() as StoreStateType
    const apiQuery = getCleanQueryObj(query) as Partial<TimeSlotParamType>

    try {
      const { data } = await fetchTimeSlotListApi(apiQuery.loadingDockId as number, {
        page: 'MASTER_TIME_SLOT',
      })
      return (data?.data as TimeSlotDataType[]) || []
    } catch (error) {
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const updateTimeSlot = createAsyncThunk(
  `${SLICE_NAME}/updateTimeSlot`,
  async (
    payload: { id: number; name: string } & UpdateTimeSlotDataType,
    { dispatch, getState },
  ) => {
    const { id, name, ...data } = payload
    try {
      const {
        timeSlot: { query },
      } = getState() as StoreStateType
      const apiQuery = getCleanQueryObj(query) as Partial<TimeSlotParamType>

      await putTimeSlotApi(apiQuery.loadingDockId as number, id, data)
      dispatch(fetchTimeSlotList())
      toastSuccess(`${name} berhasil diatur.`)
    } catch (error) {
      callErrorMsg(error)
    }
  },
)

export const upsertFcfsTimeSlot = createAsyncThunk(
  `${SLICE_NAME}/upsertFcfsTimeSlot`,
  async (
    { payload, onSuccess }: { payload: UpsertFcfsTimeSlotDataType; onSuccess: () => void },
    { dispatch, getState },
  ) => {
    try {
      const {
        timeSlot: { query },
      } = getState() as StoreStateType
      const apiQuery = getCleanQueryObj(query) as Partial<TimeSlotParamType>

      await upsertFcfsTimeSlotApi(apiQuery.loadingDockId as number, payload)
      dispatch(fetchTimeSlotList())
      toastSuccess(
        payload.ldts_ids?.length === 0
          ? 'Berhasil hapus antrian'
          : `Berhasil simpan antrian ${payload.fcfs_index}`,
      )
      onSuccess()
    } catch (error) {
      callErrorMsg(error)
    }
  },
)
